import { Component, OnInit, OnDestroy, Input, AfterViewInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Logger } from 'src/app/api/helper/app-error-logger';

import JsBarcode from 'jsbarcode';

@Component({
    selector: 'app-barcode',
    templateUrl: './barcode.component.html',
    styleUrls: ['./barcode.component.scss'],
    standalone: false
})
export class BarcodePage implements OnInit, OnDestroy, AfterViewInit {
    log = new Logger('BarcodePage');

    subscriptions: Subscription[] = [];

    @Input() barcode: string;

    isVisible = false;

    constructor() { }

    ngOnInit() {
    }

    async ngAfterViewInit() {
        this.log?.info('ngAfterViewInit: ' + this.barcode);

        const format = 'CODE39'; // AppConfig.current.einstellungen.AuftragBarcodeTyp;

        JsBarcode("#barcode", this.barcode, {
            format,
            height: 150,
            width: 5,
            displayValue: false
        });
    }

    ngOnDestroy() {
    }

    async ionViewWillEnter() {
    }

    ionViewDidEnter() {
        this.log?.info('ionViewDidEnter: ' + this.barcode);
    }

    ionViewWillLeave() {
    }
}
